import { render, staticRenderFns } from "./SurveyPackageAdd.vue?vue&type=template&id=6d52c216&scoped=true&"
import script from "./SurveyPackageAdd.vue?vue&type=script&lang=js&"
export * from "./SurveyPackageAdd.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPackageAdd.vue?vue&type=style&index=0&id=6d52c216&prod&scoped=true&lang=css&"
import style1 from "./SurveyPackageAdd.vue?vue&type=style&index=1&id=6d52c216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52c216",
  null
  
)

export default component.exports